(() => {
  const config = document.querySelector('[data-mys-promotions]');
  if (!config) return;
  const preview = config.dataset.designMode === 'true';
  const campaigns = [
    { name: 'halloween', start: '2026-10-19T04:00:00Z', end: '2026-11-01T04:00:00Z', ready: config.dataset.halloweenReady === 'true' },
    { name: 'autumn', start: '2026-09-14T04:00:00Z', end: '2026-10-19T04:00:00Z', ready: config.dataset.autumnReady === 'true' }
  ];
  let timer;
  function sync() {
    clearTimeout(timer);
    const now = Date.now();
    let next = 60000;
    campaigns.forEach(campaign => {
      const start = Date.parse(campaign.start), end = Date.parse(campaign.end);
      const active = campaign.ready && now >= start && now < end;
      const visible = active || (preview && campaign.name === 'halloween');
      if (!visible) {
        document.querySelectorAll(`[data-mys-promotion="${campaign.name}"]`).forEach(node => { node.hidden = true; });
        document.querySelectorAll(`[data-seasonal-fallback="${campaign.name}"]`).forEach(node => { node.hidden = false; });
        document.querySelectorAll('nav a[href], .menu-drawer a[href]').forEach(link => {
          const path = new URL(link.href, window.location.origin).pathname.replace(/\/$/, '');
          if (path.endsWith(`/pages/${campaign.name}-sale`)) (link.closest('li') || link).hidden = true;
        });
      }
      [start, end].forEach(boundary => { if (boundary > now) next = Math.min(next, boundary - now + 50); });
    });
    timer = setTimeout(sync, next);
  }
  sync();
  document.addEventListener('visibilitychange', () => { if (!document.hidden) sync(); });
  document.addEventListener('shopify:section:load', sync);
})();
